import { Collapse } from "antd";
import styled from "styled-components";
import color from "../_style/color";

const ProfileCollapse = styled(Collapse).attrs(() => ({
  defaultActiveKey: ["1"],
  expandIconPosition: "right",
  bordered: false,
  accordion: true,
}))`
  background-color: white;
  width: 100%;

  .ant-collapse-header {
    line-height: 40px;
    font-size: 16px;
    color: ${color.nightRider};
    font-weight: 600;
    padding: 12px 0;
  }

  .ant-collapse-item {
    :last-child {
      border-bottom: none;
    }
  }
`;
export default ProfileCollapse;
